var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "query-settings" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.portValue === 1,
              expression: "portValue === 1",
            },
          ],
          staticClass: "page-setting dfc mb20",
        },
        [
          _c("p", { staticClass: "setting-title" }, [_vm._v("查询页数：")]),
          _c(
            "el-radio-group",
            {
              on: {
                change: function ($event) {
                  return _vm.radioChange(2)
                },
              },
              model: {
                value: _vm.portPagesValue,
                callback: function ($$v) {
                  _vm.portPagesValue = $$v
                },
                expression: "portPagesValue",
              },
            },
            _vm._l(_vm.portPages, function (item, index) {
              return _c("el-radio", { key: index, attrs: { label: index } }, [
                _vm._v(_vm._s(item) + "个"),
              ])
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.portValue === 0,
              expression: "portValue === 0",
            },
          ],
          staticClass: "page-setting dfc mb20",
        },
        [
          _c("p", { staticClass: "setting-title" }, [_vm._v("查询页数：")]),
          _c(
            "el-radio-group",
            {
              on: {
                change: function ($event) {
                  return _vm.radioChange(3)
                },
              },
              model: {
                value: _vm.pageValue,
                callback: function ($$v) {
                  _vm.pageValue = $$v
                },
                expression: "pageValue",
              },
            },
            _vm._l(_vm.pages, function (item, index) {
              return _c("el-radio", { key: index, attrs: { label: index } }, [
                _vm._v(_vm._s(item) + "页"),
              ])
            }),
            1
          ),
        ],
        1
      ),
      _vm._t("default"),
      _c(
        "div",
        { staticClass: "keywords-setting mt20 dfc" },
        [
          _c("p", { staticClass: "setting-title" }, [_vm._v("查询关键词：")]),
          _c(
            "div",
            { staticStyle: { position: "relative" } },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom-start",
                    width: "446",
                    trigger: "click",
                    disabled: _vm.records.length === 0,
                  },
                },
                [
                  _c("div", { staticClass: "record-keyword" }, [
                    _c("p", { staticClass: "record-keyword-title" }, [
                      _vm._v("最近搜索"),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "dfc",
                        staticStyle: { "flex-wrap": "wrap" },
                      },
                      _vm._l(_vm.records, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "record-keyword-item",
                            on: {
                              click: function ($event) {
                                return _vm.selectKeyword(item)
                              },
                            },
                          },
                          [
                            _c("p", [_vm._v(_vm._s(item))]),
                            _c(
                              "i",
                              {
                                staticClass: "del",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.delKeyword(item, index)
                                  },
                                },
                              },
                              [_vm._v("×")]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _c("el-input", {
                    staticStyle: { width: "350px" },
                    attrs: {
                      slot: "reference",
                      type: "textarea",
                      rows: 5,
                      placeholder: "请输入内容",
                      resize: "none",
                    },
                    on: { change: _vm.handleKeyword },
                    slot: "reference",
                    model: {
                      value: _vm.keyword,
                      callback: function ($$v) {
                        _vm.keyword = $$v
                      },
                      expression: "keyword",
                    },
                  }),
                ],
                1
              ),
              _c("p", [_vm._v(_vm._s(_vm.keywordArr.length) + "/5")]),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "10px", width: "126px" },
              attrs: { type: "primary", size: "medium" },
              on: { click: _vm.rankingQuery },
            },
            [_vm._v("排名查询")]
          ),
        ],
        1
      ),
      _vm._m(0),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tips mt20 dfc" }, [
      _c("div", { staticClass: "title" }, [
        _c("i", { staticClass: "iconfont-npm icon-npm-gantan skyFont" }),
        _c("span", { staticClass: "ml3" }, [_vm._v("特别提示：")]),
      ]),
      _c("div", { staticClass: "tips-content" }, [
        _c("p", [
          _vm._v(
            " 1、排名查询功能受1688官方影响，短时间内频繁查询可能会被屏蔽IP，如出现屏蔽提示，请休息一段时间后重新登录操作。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            "2、排名查询结果受千人千面及电脑缓存影响，可能存在小误差，但不影响运营数据分析和参考。"
          ),
        ]),
        _c("p", [
          _vm._v(
            "3、若排名查询的关键字较多，且查询的页数是1-200个，则需较长时间，建议分批查询。"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }